"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _color = require("../../style/utils/color");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const fadeIn = (0, _styledComponents.keyframes)`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const tooltipColor = (type, theme, bgColor) => {
  if (bgColor) return (0, _color.toColor)(theme, bgColor);
  return type === "error" ? theme.colors.error : theme.colors.black;
};

const tooltipOffset = (position, inputSize, isPartOfInput) => {
  if (!isPartOfInput) {
    return {
      [position]: "1px"
    };
  }

  switch (inputSize) {
    case "small":
      return `
        ${position}: 5px;
        @-moz-document url-prefix() { 
          ${position}: ${["top", "bottom"].includes(position) ? "7px" : "6px"};
        }
      `;

    case "large":
      return `
        ${position}: ${["top", "bottom"].includes(position) ? "0px" : "-2px"};
        @-moz-document url-prefix() { 
          ${position}: -1px;
        }
      `;

    default:
      return `
        ${position}: ${["top", "bottom"].includes(position) ? "4px" : "2px"};
        @-moz-document url-prefix() { 
          ${position}: 4px;
        }
      `;
  }
};

const StyledTooltipWrapper = _styledComponents.default.div`
  ${({
  position,
  size,
  theme,
  type,
  isPartOfInput,
  inputSize,
  bgColor,
  fontColor
}) => (0, _styledComponents.css)`
    bottom: auto;
    right: auto;
    max-width: 300px;
    position: relative;
    animation: ${fadeIn} 0.2s linear;
    z-index: ${theme.zIndex.popover};
    text-align: left;
    color: ${fontColor ? (0, _color.toColor)(theme, fontColor) : theme.colors.white};
    display: inline-block;
    padding: 8px 12px;
    word-break: break-word;
    white-space: pre-wrap;
    font-size: ${size === "medium" ? "14px" : "16px"};
    line-height: 1.5rem;
    font-weight: 400;
    background-color: ${tooltipColor(type, theme, bgColor)};
    ${tooltipOffset(position, inputSize, isPartOfInput)};
  `}
`;
StyledTooltipWrapper.propTypes = {
  type: _propTypes.default.string,
  size: _propTypes.default.oneOf(["medium", "large"])
};
StyledTooltipWrapper.defaultProps = {
  theme: _base.default,
  size: "medium",
  inputSize: "medium",
  position: "top"
};
var _default = StyledTooltipWrapper;
exports.default = _default;